export enum ParticipantPresence {
  PRESENT = 'PRESENT',
  EXCUSED = 'EXCUSED',
  ABSENT = 'ABSENT',
  LATE_REGISTRATION = 'LATE_REGISTRATION',
  WANT_STOP = 'WANT_STOP',
  TRIAL = 'TRIAL'
}
